import React, {Component, useEffect, useState} from 'react';
import ReactPaginate from 'react-paginate';

const PaginatedItems = ({total, onPageChange, currentPage = 1, pageSize = 10}) => {
    // Here we use item offsets; we could also use page offsets
    // following the API or data you're working with.
    const [itemOffset, setItemOffset] = useState(0);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const itemsPerPage = pageSize;
    
    // Simulate fetching items from another resources.
    // (This could be items from props; or items loaded in a local state
    // from an API endpoint with useEffect and useState)
    const endOffset = itemOffset + itemsPerPage;
    const pageCount = Math.ceil(total / itemsPerPage);

    // Update itemOffset when currentPage changes
    useEffect(() => {
        const newOffset = ((currentPage - 1) * itemsPerPage) % total;
        setItemOffset(newOffset);
    }, [currentPage, total, itemsPerPage]);

    // Handle window resize
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Invoke when user click to request another page.
    const handlePageClick = (event) => {
        const newOffset = (event.selected * itemsPerPage) % total;
        setItemOffset(newOffset);
        let pageNumber = event.selected + 1;
        onPageChange(pageNumber);
    };

    return (
        <>
            {isMobile && (
                <div style={{
                    textAlign: 'center',
                    color: '#6c757d',
                    fontSize: '12px',
                    marginBottom: '5px'
                }}>
                    Page {currentPage} of {pageCount}
                </div>
            )}
            <ReactPaginate
                breakLabel="..."
                nextLabel=">"
                onPageChange={handlePageClick}
                pageRangeDisplayed={isMobile ? 2 : 5}
                marginPagesDisplayed={isMobile ? 1 : 2}
                pageCount={pageCount}
                previousLabel="<"
                renderOnZeroPageCount={null}
                className={'pagination'}
                pageLinkClassName={'page-link'}
                activeClassName={'active'}
                pageClassName={'page-item'}
                nextClassName={'paginate-prev-next'}
                previousClassName={'paginate-prev-next'}
                forcePage={currentPage - 1} // ReactPaginate uses 0-based indexing
            />
        </>
    );
}

export default PaginatedItems;